import React from 'react';

// CSS
import './UploaderAd.css';

export default class UploaderAd extends React.Component {

  constructor(props) {
    super(props);

    this._numLoaded   = 0;
    this._numDropped  = 0;
  }

  componentDidMount () {
    (window.adsbygoogle = window.adsbygoogle || []).push({});
  }

  render() {
    
    return (
      <div className="UploaderAd">
        <ins className="adsbygoogle"
          style={{display: 'block'}}
          data-ad-client="ca-pub-1384900650518620"
          data-ad-slot="2143171123"
          data-ad-format="auto"
          data-full-width-responsive="true"></ins>
      </div>
    )

  }

}